<mat-slide-toggle [(ngModel)]="value">
  {{ getLabel }}
</mat-slide-toggle>
